import React from 'react';
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';

function HelpIcon() {
  const dispatch = useDispatch();
  return (
    <div
      style={{
        zIndex: '9',
        position: 'fixed',
        top: '0px',
        right: '20px',
        height: '77px',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <div
        role="button"
        tabIndex={0}
        onClick={() => dispatch({ type: 'OPEN_MODAL', modal: 'tipsModal' })}
      >
        <FontAwesomeIcon
          icon={faCircleInfo}
          style={{ color: 'var(--bs-gray-500)' }}
          size="xl"
        />
      </div>
    </div>
  );
}

export default HelpIcon;
